export enum StateType {
  Offline = 0,
  Work = 1,
  Break = 2,
  Training = 3,
  Meeting = 4,
  Other = 5,
}